import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type {
  CreateBlogItemBodyT,
  CreateBlogItemResT,
} from 'server/controllers/blog';

import { type BlogItemT, P_API_BLOG, getConfig } from 'utils';

type CreateBlogItemArgT = Omit<BlogItemT, 'id' | 'image' | 'publishedAt' | 'status'>;

export async function createBlogItem(
  arg: CreateBlogItemArgT,
): Promise<BlogItemT> {
  assertClientSide();

  const config = await getConfig();

  const res = await axios.post<CreateBlogItemResT>(P_API_BLOG, {
    _csrf: config.CSRF,
    status: 'DRAFT',
    ...arg,
  } satisfies CreateBlogItemBodyT);

  return res.data;
}
